export enum EWorkingType {
  Custom,
  AdministrativeDay,
  AllWeek
}
